import {
  RESET_PASSWORD_REQUEST_REQUEST,
  RESET_PASSWORD_REQUEST_SUCCESS,
  RESET_PASSWORD_REQUEST_FAILURE,
  RESET_RESET_PASSWORD_REQUEST_STATE,
} from "../../actionTypes/resetPasswordRequest";

interface resetPasswordRequestParams {
  email: string;
  password: string;
  confirmPassword: string;
}

export const resetPasswordRequestRequest = (payload: resetPasswordRequestParams) => ({
  type: RESET_PASSWORD_REQUEST_REQUEST,
  payload,
});

export const resetPasswordRequestSuccess = (data: string) => ({
  type: RESET_PASSWORD_REQUEST_SUCCESS,
  payload: data,
});

export const resetPasswordRequestFailure = (error: string) => ({
  type: RESET_PASSWORD_REQUEST_FAILURE,
  payload: error,
});

export const resetPasswordRequestResetState = () => ({
  type: RESET_RESET_PASSWORD_REQUEST_STATE,
});
